import React, { Component } from 'react';

import button from "bootstrap/js/src/button";
import { Tooltip } from "@mui/material";

import Loading from "../../../../component/loading/Loading";
import RadioBtnList from "../../../../component/input/RadioBtnList";
import SingleButton from "../../../../component/button/SingleButton";
import CampaignDateTimeInput from "../../../../component/input/CampaignDateTimeInput";
import SelectList from "../../../../component/input/SelectList";

import RCSFundamenFormClass from "../component/messagecreate/RCSFundamenFormClass";
import { RCS_TYPES, isRcsText, validateRcsFile } from "../../../../util/rcsTypeUtil";
import CouponChargeComp from "../../../../component/CouponChargeComp";
import ChargeModalBeforeCreate from "../../component/modal/ChargeModalBeforeCreate";
import MessageSavedModal from "../../../../component/modal/MessageSavedModal";
import ChargePressModal from "../../../../component/modal/ChargePressModal";
import MessageMosuSelectModal from "../../../../component/modal/MessageMosuSelectModal";
import MessageMapticsModal from "../../../../component/modal/MessageMapticsModal";
import MessageMapticsSportsSelectModal from "../../../../component/modal/MessageMapticsSportsSelectModal";
import MessageAIModal from "../../../../component/modal/MessageAIModal";

import * as apiUtil from "../../../../util/apiUtil";
import * as dateUtil from "../../../../util/dateUtil";
import * as stringUtil from "../../../../util/stringUtil";
import {
    applySelfScheduleChange,
    createSelfDefaultSchedule,
    compareDateTimes,
    getCollectionDeadline,
    getSelfScheduleLimits,
    isNonBusinessDay,
    toApiDateTime,
} from '../../../../util/campaignScheduleUtil';

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as selfAction from "../store/selfmessage";
import TextInput from "../../../../component/input/TextInput";
import GetMessageForRemindModal from "../../component/modal/GetMessageForRemindModal";
import { setAtsSndStartDate, setButtons, setButtonsForRemind, setSndGoalCnt } from "../store/selfmessage";

class SelfMessageCreateContainer extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setLoadingMosu = this.setLoadingMosu.bind(this);

        this.handleRCSTypeChange = this.handleRCSTypeChange.bind(this);
        this.handleUrl = this.handleUrl.bind(this);

        this.closeChargeLackModal = this.closeChargeLackModal.bind(this);
        this.closeChargeModal = this.closeChargeModal.bind(this);
        this.closeSuccessModal = this.closeSuccessModal.bind(this);

        this.openChargeLackModal = this.openChargeLackModal.bind(this);
        this.openSuccessModal = this.openSuccessModal.bind(this);
        this.openChargeModal = this.openChargeModal.bind(this);

        this.handleTargetType = this.handleTargetType.bind(this);
        this.handleMapticsValue = this.handleMapticsValue.bind(this);
        this.handleMapticsModal = this.handleMapticsModal.bind(this);
        this.handleMapticsSportsSelectModal = this.handleMapticsSportsSelectModal.bind(this);
        this.setMapticsData = this.setMapticsData.bind(this);
        this.ajaxCreateMaptics = this.ajaxCreateMaptics.bind(this);

        this.handleMosuSelectModal = this.handleMosuSelectModal.bind(this);
        this.handleMessageAIModal = this.handleMessageAIModal.bind(this);

        this.handleCPInput = this.handleCPInput.bind(this);
        this.handleRCSFile = this.handleRCSFile.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleRCSInfoChange = this.handleRCSInfoChange.bind(this);

        this.handleMMSInfoChange = this.handleMMSInfoChange.bind(this);
        this.setUrlValue = this.setUrlValue.bind(this);
        this.setMosuData = this.setMosuData.bind(this);
        this.resetMosuData = this.resetMosuData.bind(this);
        this.setMessage = this.setMessage.bind(this);
        this.changePreview = this.changePreview.bind(this);
        this.handleRemindMessage = this.handleRemindMessage.bind(this);

        this.checkAtsMosuAndCreate = this.checkAtsMosuAndCreate.bind(this);
        this.ajaxResetAtsMosu = this.ajaxResetAtsMosu.bind(this);
        this.ajaxPostCreateCP = this.ajaxPostCreateCP.bind(this);
        this.ajaxGetUserMessageInfo = this.ajaxGetUserMessageInfo.bind(this);
        this.ajaxGetCompanyList = this.ajaxGetCompanyList.bind(this);
        this.handleCouponChange = this.handleCouponChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);

        this.handleResetState = this.handleResetState.bind(this);
        this.setMSF = this.setMSF.bind(this);

        this.resetMessage = this.resetMessage.bind(this);
        this.resetRemindMessage = this.resetRemindMessage.bind(this);

        this.handleRemindModal = this.handleRemindModal.bind(this);
        this.handleRemindText = this.handleRemindText.bind(this);
        this.handleRemind = this.handleRemind.bind(this);

        this.selectChargeType = this.selectChargeType.bind(this);
        this.selectSendPeriod = this.selectSendPeriod.bind(this);
        this.setIsAIImage = this.setIsAIImage.bind(this);
        this.ajaxGetFormList = this.ajaxGetFormList.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleNaverLoginChange = this.handleNaverLoginChange.bind(this);

        // 이미지 불러오기 모달창
        // 사용 이유 => 동일 동작을 요하는 버튼이 2개가 있어 해당 ref를 통해
        this.imageButtonRef = React.createRef();

        this.state = {
            loading: false,
            loadingMosu: false,

            chargeModal: true,
            chargeLackModal: false,
            successModal: false,
            mosuSelectModal: false,
            mapticsModal: false,
            mapticsSportsSelectModal: false,
            messageAIModal: false,

            openRemindModal: false,
            remindCmpnId: '',

            preview: null,

            useReward: false,

            isAIChecked: false,

            aiState: {
                aiGenerated: false,
                isFirst: true,
                isChanged: false
            },

            remindMessage: null,
            isRemind: false,
            isRemindText: false,
            usePackage: false,
            sendPeriod: 7,

            userInfoData: {},
            isAIImage: false,

            formList: [],
            selectedFormUid: '',
            isFormAdded: 'N',

            hasNaverApp: false,
            isNaverLoginAdded: 'N',
            naverRedirectUrl: '',
            naverLoginText: '',
            companyList: [],
            tgtCompanyName: '',

        }// end state
    }// end constructor

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.state.loadingMosu !== nextState.loadingMosu
            || this.state.loadingText !== nextState.loadingText
            || this.state.aiState?.aiGenerated !== nextState.aiState?.aiGenerated
            || this.state.aiState?.isFirst !== nextState.aiState?.isFirst
            || this.state.aiState?.isChanged !== nextState.aiState?.isChanged
            || this.state.preview !== nextState.preview
            || this.state.useReward !== nextState.useReward
            || this.state.chargeModal !== nextState.chargeModal
            || this.state.chargeLackModal !== nextState.chargeLackModal
            || this.state.successModal !== nextState.successModal
            || this.state.mosuSelectModal !== nextState.mosuSelectModal
            || this.state.mapticsModal !== nextState.mapticsModal
            || this.state.mapticsSportsSelectModal !== nextState.mapticsSportsSelectModal
            || this.state.mainCateID !== nextState.mainCateID
            || this.state.midCateID !== nextState.midCateID
            || this.state.subCateID !== nextState.subCateID
            || this.props.name !== nextProps.name
            || this.props.RCSInfo !== nextProps.RCSInfo
            || this.props.RCSType !== nextProps.RCSType
            || this.props.rcsType !== nextProps.rcsType
            || this.props.urlCount !== nextProps.urlCount
            || this.props.couponList !== nextProps.couponList
            || this.props.selectedCoupon !== nextProps.selectedCoupon
            || this.props.cashAmount !== nextProps.cashAmount
            || this.props.freeAmount !== nextProps.freeAmount
            || this.props.txtMessageUnit !== nextProps.txtMessageUnit
            || this.props.imgMessageUnit !== nextProps.imgMessageUnit
            || this.props.messageType !== nextProps.messageType
            || this.props.callback !== nextProps.callback
            || this.props.sndGoalCnt !== nextProps.sndGoalCnt
            || this.props.atsSndStartDate !== nextProps.atsSndStartDate
            || this.props.MmsInfo !== nextProps.MmsInfo
            || this.props.MmsInfo.urlLink !== nextProps.MmsInfo.urlLink
            || (this.props.MmsInfo.urlLink?.list?.length ?? 0) !== (nextProps.MmsInfo.urlLink?.list?.length ?? 0)
            || this.props.mosuCnt !== nextProps.mosuCnt
            || this.props.mosuQuery !== nextProps.mosuQuery
            || this.props.mosuDesc !== nextProps.mosuDesc
            || this.props.mosuJson !== nextProps.mosuJson
            || this.props.MMSFile !== nextProps.MMSFile
            || this.props.RCSFile !== nextProps.RCSFile
            || this.props.imgName !== nextProps.imgName
            || this.props.rewardUrl !== nextProps.rewardUrl
            || this.props.ageFrom !== nextProps.ageFrom
            || this.props.ageTo !== nextProps.ageTo
            || this.props.billingType !== nextProps.billingType
            || this.props.targetType !== nextProps.targetType
            || this.props.mapticsSendType !== nextProps.mapticsSendType
            || this.props.collStartDate !== nextProps.collStartDate
            || this.props.collEndDate !== nextProps.collEndDate
            || this.props.collSndDate !== nextProps.collSndDate
            || this.props.rtEndHour !== nextProps.rtEndHour
            || this.props.rtEndMinute !== nextProps.rtEndMinute
            || this.props.mapticsData !== nextProps.mapticsData
            || this.props.mapticsTargetId !== nextProps.mapticsTargetId
            || this.props.createdCampaignUid !== nextProps.createdCampaignUid
            || this.props.aiCreated !== nextProps.aiCreated
            || this.state.openRemindModal !== nextState.openRemindModal
            || this.state.isRemind !== nextState.isRemind
            || this.state.remindCmpnId !== nextState.remindCmpnId
            || this.state.isRemindText !== nextState.isRemindText
            || this.props.userPackage !== nextState.userPackage
            || this.state.usePackage !== nextState.userPackage
            || this.state.sendPeriod !== nextState.sendPeriod
            || this.state.isAIImage !== nextState.isAIImage
            || this.state.selectedFormUid !== nextState.selectedFormUid
            || this.state.isFormAdded !== nextState.isFormAdded
            || this.state.isNaverLoginAdded !== nextState.isNaverLoginAdded
            || this.state.naverRedirectUrl !== nextState.naverRedirectUrl
            || this.state.naverLoginText !== nextState.naverLoginText
            || this.state.hasNaverApp !== nextState.hasNaverApp
            || this.state.companyList !== nextState.companyList
            || this.state.tgtCompanyName !== nextState.tgtCompanyName
        )
    }// end shouldComponentUpdate
    componentDidMount() {
        this._isMounted = true;
        this.props.SelfAction.setSchedule(createSelfDefaultSchedule());
        this.ajaxGetUserMessageInfo();
        this.ajaxGetCompanyList();
        this.ajaxGetFormList();
        apiUtil.asyncRequest({
            url: "/api/bizchat/naver-app/check",
            method: apiUtil.requestMethod.GET,
            success: (result) => {
                this.setState({ hasNaverApp: result.hasApp === true });
            },
        });
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }
    setLoadingMosu(loading, text) {
        this.setState({ loadingMosu: loading, loadingText: text });
    }

    setIsAIImage(isChecked) {
        this.setState({ isAIImage: isChecked });
    }

    handleResetState = () => {
        this.setState({
            chargeModal: true,
            chargeLackModal: false,
            successModal: false,

            preview: null,
        });
    };

    handleTargetType(id, value) {
        const { SelfAction, targetType, mapticsSendType, atsSndStartDate, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute } = this.props;
        const { isRemind } = this.state;

        if (isRemind) return;

        switch (id) {
            case "targetType":
                SelfAction.setSchedule(applySelfScheduleChange({
                    targetType,
                    mapticsSendType,
                    atsSndStartDate,
                    collStartDate,
                    collEndDate,
                    collSndDate,
                    rtEndHour,
                    rtEndMinute,
                }, id, value, { isRemind }));
                break;
            default:
                break;
        }
    }

    handleMapticsValue(id, value) {
        const { SelfAction, targetType, mapticsSendType, atsSndStartDate, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute } = this.props;
        const { isRemind } = this.state;

        switch (id) {
            case "mapticsSendType":
            case "collStartDate":
            case "collEndDate":
            case "collSndDate":
            case "rtEndHour":
            case "rtEndMinute":
                if (id === 'collSndDate' && isNonBusinessDay(value)) {
                    alert("발송 일자를 주말, 공휴일로 설정 하셨습니다.\n 주말 및 공휴일 발송 시 기재하신 고객센테에서 CS 처리가 가능하여야 합니다.");
                }
                SelfAction.setSchedule(applySelfScheduleChange({
                    targetType,
                    mapticsSendType,
                    atsSndStartDate,
                    collStartDate,
                    collEndDate,
                    collSndDate,
                    rtEndHour,
                    rtEndMinute,
                }, id, value, { isRemind }));
                break;
        }
    }

    handleMapticsSportsSelectModal() {
        const { mapticsSportsSelectModal } = this.state;
        this.setState({ mapticsSportsSelectModal: !mapticsSportsSelectModal });
    }

    handleMapticsModal() {
        const { mapticsModal } = this.state;
        this.setState({ mapticsModal: !mapticsModal });
    }

    setMapticsData(mapticsData) {
        const { SelfAction } = this.props;
        SelfAction.setMapticsData(mapticsData);
    }

    handleAICheckChange = (checked) => {
        this.setState({
            isAIChecked: checked,
        });
    }

    // "발송 서비스 선택시 동작"
    async handleRCSTypeChange(id, value) {
        /*RCS type 변경시 rcsType, billingType 변경*/
        const { SelfAction, userPackage } = this.props;
        const { isRemind } = this.state;

        if (isRemind) return;

        const type = value === '텍스트' ? 1 : value === '이미지' ? 0 : Number(value);
        if (!RCS_TYPES.some(item => item.value === type)) return;
        if (Number(this.props.rcsType) === type) return;
        SelfAction.setRcsType(isRcsText(type) ? '텍스트' : '이미지');
        this.setState({ isAIImage: false, preview: null });
        await SelfAction.setRCSFile(0, null);
        await SelfAction.setMMSFile(null);
        await SelfAction.setRcsInfoImgOrigId('', 0);
        await SelfAction.setMmsFileOrigId('', 0);
        await SelfAction.setImgName('');
        if (isRcsText(type)) {
            await SelfAction.setMessageType("일반 문자메시지-텍스트");
            await SelfAction.setBillingType(3);
            await SelfAction.setrcsType(type);
            if (userPackage !== null && userPackage !== undefined && userPackage.canUsed === 'Y' && userPackage.type === 'T') {
                this.setState({ usePackage: true });
                await SelfAction.setSndGoalCnt(userPackage.sendCnt);
            } else {
                this.setState({ usePackage: false });
                await SelfAction.setSndGoalCnt(1000);
            }
        } else {
            await SelfAction.setMessageType("일반 문자메시지-이미지");
            await SelfAction.setBillingType(1);
            await SelfAction.setrcsType(type);
            if (userPackage !== null && userPackage !== undefined && userPackage.canUsed === 'Y' && userPackage.type === 'I') {
                this.setState({ usePackage: true });
                await SelfAction.setSndGoalCnt(userPackage.sendCnt);
            } else {
                this.setState({ usePackage: false });
                await SelfAction.setSndGoalCnt(1000);
            }
        }
    } // end RCSType ==> [이미지, 텍스트]

    /*모달창 닫는 애들*/
    closeChargeModal() { this.setState({ chargeModal: false }) }

    closeSuccessModal() {
        this.setState({ successModal: false });
        window.location.href = "/sent/list";
    }
    closeChargeLackModal() { this.setState({ chargeLackModal: false }) }

    openChargeModal() { this.setState({ chargeModal: true }) }

    openSuccessModal() { this.setState({ successModal: true }) }
    openChargeLackModal() { this.setState({ chargeLackModal: true }) }

    handleMosuSelectModal() {
        const { mosuSelectModal } = this.state;
        this.setState({ mosuSelectModal: !mosuSelectModal });
    }

    handleMessageAIModal() {
        const { messageAIModal } = this.state;
        this.setState({ messageAIModal: !messageAIModal })
    }

    async setMessage(title, message) {
        const { SelfAction, selectedSlide } = this.props;
        const { MmsMsg, RcsInfo } = this.state;

        // 1. message 에서 url 및 개수 추출
        const rawUrls = message.match(/https?:\/\/[^\s)"}>'\]]+/g) || [];
        const cleanedUrls = rawUrls.map(url =>
            url.replace(/[ㄱ-ㅎ가-힣).,"\]}']+$/g, '') // 한글 조사는 끝에서 제거
        );

        // 2. title, message, url 변수에 할당
        SelfAction.setRcsInfoTitle(title, 0);
        SelfAction.setMmsTitle(title);
        SelfAction.setName(title);

        SelfAction.setRcsInfoMsg(message, 0);
        SelfAction.setMmsMsg(message);

        SelfAction.setRcsUrl(cleanedUrls, selectedSlide - 1);
        SelfAction.setMmsUrl(cleanedUrls);


        let newUrlCount = [];
        if (cleanedUrls.length === 0) newUrlCount = [];
        else if (cleanedUrls.length === 1) newUrlCount = [1];
        else if (cleanedUrls.length === 2) newUrlCount = [1, 2];
        else if (cleanedUrls.length === 3) newUrlCount = [1, 2, 3];

        SelfAction.setUrlCount(newUrlCount);

        SelfAction.setAiCreated(true);

    }

    handleUrl(value, index) {
        const { SelfAction } = this.props;

        const urls = value.match(/https?:\/\/[^\s]+/g) || [];

        // URL 개수 배열 (기존 방식 유지)
        let newUrlCount = [];
        for (let i = 1; i <= urls.length; i++) newUrlCount.push(i);

        SelfAction.setUrlCount(newUrlCount);
        SelfAction.setRcsUrl(urls, index);
        SelfAction.setMmsUrl(urls);
    }// end handleUrl

    resetMessage() {
        const { SelfAction, selectedSlide, targetType, mapticsSendType } = this.props;
        this.setState({
            isRemind: false,
            isRemindText: false, // Changed from isRemindMessage to isRemindText based on context
            aiState: {
                aiGenerated: false,
                isFirst: true,
                isChanged: false
            },
            selectedFormUid: '',
            isFormAdded: 'N',
            isNaverLoginAdded: 'N',
            naverRedirectUrl: '',
            naverLoginText: '',
            tgtCompanyName: this.state.companyList[0]?.companyName || '',
        });
        SelfAction.setSchedule(createSelfDefaultSchedule({ targetType, mapticsSendType }));
        SelfAction.setAiCreated(false);

        this.handleRCSInfoChange("title", "");
        this.handleRCSInfoChange("msg", "");

        SelfAction.setUrlCount([]);
        SelfAction.setRcsUrl([], selectedSlide - 1);
        SelfAction.setMmsUrl([]);
        SelfAction.setName('');
    }

    resetRemindMessage() {
        const { SelfAction, selectedSlide } = this.props;
        const { userInfoData } = this.state;
        SelfAction.setInitialState();
        SelfAction.setCouponList(userInfoData.couponList);
        SelfAction.setCashAmount(userInfoData.amount);
        SelfAction.setFreeAmount(userInfoData.freeAmount);
        SelfAction.setTxtMessageUnit(userInfoData.txtMessageUnit);
        SelfAction.setImgMessageUnit(userInfoData.imgMessageUnit);
        SelfAction.setSchedule(createSelfDefaultSchedule());

        return new Promise(resolve => {
            this.setState({
                isRemind: false,
                isRemindText: false,
                aiState: {
                    aiGenerated: false,
                    isFirst: true,
                    isChanged: false
                },
                preview: null,
                useReward: false,
                isAIChecked: false,
                selectedFormUid: '',
                isFormAdded: 'N',
                isNaverLoginAdded: 'N',
                naverRedirectUrl: '',
                naverLoginText: '',
                tgtCompanyName: this.state.companyList[0]?.companyName || '',
            }, resolve);
        });
    }

    async handleRemind(value) {
        if (!this._isMounted) return; // 마운트 여부 체크
        await this.resetRemindMessage();
        // 1. 필요한 state 업데이트
        await new Promise(resolve => {
            this.setState({
                isRemind: true,
                isRemindText: false,
                aiState: {
                    aiGenerated: true,
                    isFirst: false,
                    isChanged: true
                }
            }, resolve);
        });

        // 2. 메시지 셋팅
        await this.handleRemindMessage(value);
    }

    async handleRemindText(value) {
        if (!this._isMounted) return; // 마운트 여부 체크
        const { SelfAction } = this.props;
        // 1. 기존 값 초기화
        await this.resetRemindMessage();

        SelfAction.setButtonsForRemind(0, value.rcs[0]?.buttons?.list);

        // 2. 필요한 state 업데이트
        await new Promise(resolve => {
            this.setState({
                isRemindText: true,
                isRemind: false,
                aiState: {
                    aiGenerated: true,
                    isFirst: true,
                    isChanged: false
                }
            }, resolve);
        });

        // 3. 메시지 셋팅
        await this.setMessage(value.rcs[0].title, value.rcs[0].msg);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /*input 관리*/
    async handleRCSFile(file) {
        const { SelfAction, selectedSlide } = this.props;
        await SelfAction.setRCSFile(selectedSlide - 1, file);
        await SelfAction.setMMSFile(file);
    }// end handleMainFile
    async handleFileChange(file) {
        const { SelfAction } = this.props;
        const type = this.props.rcsType;
        if (!(await validateRcsFile(file, type)) || this.props.rcsType !== type) return;
        this.handleRCSFile(file);
        // const file = e.target.files[0];
        if (file) {
            // await SelfAction.setRcsInfoImgOrigId('', index);
            await SelfAction.setRcsInfoImgOrigId('', 0);
            const objectUrl = URL.createObjectURL(file);
            // 2026-03-18 fix: {…this.state} 스프레드 제거 - Safari 무한 로딩 버그 수정
            this.setState({ preview: objectUrl });
        }
    }// end handleFileChange
    handleRCSInfoChange(id, value) {
        const { SelfAction, selectedSlide } = this.props;
        switch (id) {
            case "title":
                // if (value.length > 30) {
                //     alert("제목은 30자까지만 가능합니다!");
                //     value = value.slice(0, 31);
                // }
                SelfAction.setName(value);
                SelfAction.setRcsInfoTitle(value, selectedSlide - 1);
                SelfAction.setMmsTitle(value);
                break;
            case "msg":
                // if (value.length > 900) {
                //     alert("내용은 1000자까지만 가능합니다!");
                //     value = value.slice(0, 901);
                // }
                SelfAction.setRcsInfoMsg(value, selectedSlide - 1);
                SelfAction.setMmsMsg(value);
                this.handleUrl(value, selectedSlide - 1);
                break;
            default:
                break;
        }
    }// end handleRCSInfoChange
    async handleMMSInfoChange(id, value) {
        const { SelfAction } = this.props;
        switch (id) {
            case "title":
                await SelfAction.setMmsTitle(value);
                break;
            case "msg":
                await SelfAction.setMmsMsg(value);
                break;
            default:
                break;
        }
    }// end handleMMSInfoChange
    async handleCPInput(id, value) {
        const { SelfAction, targetType, mapticsSendType, atsSndStartDate, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute } = this.props;
        const { isRemind } = this.state;
        switch (id) {
            case "sendDate":
                SelfAction.setSchedule(applySelfScheduleChange({
                    targetType,
                    mapticsSendType,
                    atsSndStartDate,
                    collStartDate,
                    collEndDate,
                    collSndDate,
                    rtEndHour,
                    rtEndMinute,
                }, 'atsSndStartDate', value, { isRemind }));
                break;
            case "sndGoalCnt":
                let sndGoalCnt = stringUtil.pureNumber(value)
                await SelfAction.setSndGoalCnt(sndGoalCnt);
                break;
            case "sndNum":
                await SelfAction.setSndNum(value);
                break;
            case "imgName":
                await SelfAction.setImgName(value);
                break;
            case "imgFile":
                await this.handleFileChange(value);
                break;
            case "useReward":
                await this.setState({ useReward: value });
                break;
            case "rewardUrl":
                await SelfAction.setRewardUrl(value);
                break;
            case "remindMessage":
                await this.handleRemind(value);
                break;
            case "remindText":
                await this.handleRemindText(value)
                break;
            default:
                break;
        }// end switch
    }// end handleSendDate

    async handleRemindMessage(value) {
        const { SelfAction } = this.props;

        SelfAction.setSndNum(value.campaign.sndNum);
        SelfAction.setName(value.rcs[0].title);
        SelfAction.setRcsInfo(value.rcs);
        SelfAction.setMms(value.mms);

        if (value.rcsImgUrls) {
            this.setState({ preview: value.rcsImgUrls[0] });
        } else {
            this.setState({ preview: null });
        }
        this.setState({
            remindCmpnId: value.campaign.cmpnId,
            naverRedirectUrl: value.campaign.naverRedirectUrl || '',
        });

        SelfAction.setRcvType(value.campaign.rcvType);
        SelfAction.setrcsType(value.campaign.rcsType);
        SelfAction.setRcsType(value.campaign.billingType === 3 ? "텍스트" : "이미지");
        SelfAction.setBillingType(value.campaign.billingType);
        SelfAction.setMosuQuery(value.campaign.sndMosuQuery);
        SelfAction.setMosuDesc(value.campaign.sndMosuDesc);
        SelfAction.setMosuJson(value.campaign.sndMosuJson);
        SelfAction.setMosuCnt(value.campaign.sndMosu);
        SelfAction.setMessageType(value.campaign.billingType === 3 ? "일반 문자메시지-텍스트" : "일반 문자메시지-이미지");

        if (!value.geofence) {
            SelfAction.setSchedule(createSelfDefaultSchedule({
                isRemind: true,
                targetType: 'ATS',
            }));

        } else {
            const stadiumAddresses = [
                '서울 송파구 올림픽로 25 서울종합운동장',
                '서울 구로구 경인로 430 고척스카이돔',
                '인천 미추홀구 매소홀로 618 문학경기장',
                '경기 수원시 장안구 경수대로 893 수원종합운동장',
                '대전 중구 대종로 373 한밭종합운동장',
                '대구 수성구 야구전설로 1 대구삼성라이온즈파크',
                '부산 동래구 사직로 45 사직야구장',
                '광주 북구 서림로 10 무등종합경기장',
                '경남 창원시 마산회원구 삼호로 63 마산종합운동장'
            ];

            const address = value.geofence.target[0].address;
            const stadiumIndex = stadiumAddresses.indexOf(address);
            const targetType = stadiumIndex !== -1 ? 'STADIUM' : 'MAPTICS';
            if (stadiumIndex !== -1) {
                value.geofence.target[0].stadiumId = stadiumIndex + 1;
            }
            const mapticsSendType = value.campaign.rcvType === 2 ? 'maptics_collect' : 'maptics_realtime';

            SelfAction.setSchedule(createSelfDefaultSchedule({
                isRemind: true,
                targetType,
                mapticsSendType,
            }));

            SelfAction.setMapticsData(value.geofence.target[0]);
            SelfAction.setMapticsTargetId(value.geofence.geofenceId);
            SelfAction.setAiCreated(true);
        }
    }

    async setUrlValue(value, index) {
        const { SelfAction, selectedSlide } = this.props;

        await SelfAction.updateRcsUrl(value, index, selectedSlide - 1);
        await SelfAction.updateMmsUrl(value, index);
    }// end setUrlValue

    // SelfMessageCreateContainer에서 preview 는 "이미지 미리보기"
    changePreview(url) {
        this.setState({ preview: url });
    }
    async setMSF(value) {
        const { SelfAction } = this.props;
        await SelfAction.setMMSFile(value);
    }

    checkAtsMosuAndCreate() {
        const { sndGoalCnt, mosuCnt, targetType, mapticsSendType, mapticsData, collStartDate, collEndDate, collSndDate, RCSInfo, MmsInfo, selectedSlide } = this.props;
        const { aiState, isRemind, isRemindText, usePackage } = this.state;

        let confirmMessage = "해당 내용으로 저장하시겠습니까?";

        if (targetType === "ATS") {
            const recommendedCount = Math.round(sndGoalCnt * 1.5);
            confirmMessage += "\n\n- 목표 발송 건수가 추출한 모수보다 권장 건수 미만으로 메시지가 발송 될 경우, 목표발송 건수에 미도달 할 수도 있습니다.\n" +
                "- 권장 건수 : " + sndGoalCnt + " * 1.5 = " + recommendedCount + "건";
        }

        if (!window.confirm(confirmMessage)) return;

        const titleLimit = (isRemind || isRemindText) ? 30 : 24;

        if (RCSInfo[selectedSlide - 1].title.length > titleLimit || MmsInfo.title.length > titleLimit) {
            alert(`제목은 ${titleLimit}자를 넘을 수 없습니다.`);
            return;
        }

        if(RCSInfo[selectedSlide - 1].msg.length > 850 || MmsInfo.msg.length > 850){
            alert("본문은 850자를 넘을 수 없습니다.");
            return;
        }

        if (! aiState.aiGenerated || (aiState.isFirst && aiState.isChanged)) {
            alert("AI 검수를 먼저 진행해주세요.");
            return;
        }

        for (let i = 0; i < RCSInfo.length; i++) {
            const list = RCSInfo[i]?.buttons?.list;

            if (!Array.isArray(list) || list.length === 0) continue;
            for (let btn of list) {
                const value = btn?.val1;
                const name = btn?.name;
                const val2 = btn?.val2;
                const type = btn?.type;
                if (
                    value === null ||
                    value === undefined ||
                    (typeof value === "string" && ((type !== '2' && (value.trim() === "" || value.trim() === "https://" || value.trim() === "http://"))
                        || (type === '2' && value.trim() === ""))
                    )
                ) {
                    alert("버튼 링크 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }
                if (name === null || name === undefined || name.trim() === "") {
                    alert("버튼명 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }
                if (type === '2' && (val2.trim() === "" || val2.trim() === "https://" || val2.trim() === "http://")) {
                    alert("버튼 링크 항목에 비어있는 값이 있습니다. 입력을 완료해주세요.");
                    return;
                }

            }
        }

        if (targetType === "ATS") {
            if(isRemind && mosuCnt < sndGoalCnt) {
                alert('발송 타깃 인원이 목표 발송 건수보다 적습니다.\n리마인드의 경우 발송 타깃 수정이 불가합니다.\n문구 불러오기를 통해 발송 타깃을 새로 설정해주세요.');
            } else if (mosuCnt > 400000) {
                this.ajaxResetAtsMosu();
            } else if (mosuCnt > 0 && mosuCnt <= 400000) {
                const mCnt = Number(mosuCnt);
                const sNum = Number(sndGoalCnt);
                if(mCnt < sNum) {
                    alert('발송 타깃 인원이 목표 발송 건수보다 적습니다.');
                    return;
                } else if(usePackage && mCnt < 500) {
                    alert('패키지 사용 시 발송 타깃 인원은 최소 500명 이상이어야 합니다.');
                    return;
                } else if(!usePackage && mCnt < 1000 && mCnt !== sNum) {
                    alert('발송 타깃 인원이 1000명 이하인 경우 발송 타깃 인원과 발송 희망 건수가 동일해야합니다.');
                    return;
                } else if(!usePackage && mCnt >= 1000 && sNum < 1000) {
                    alert('발송 타깃 인원이 1000명 이상인 경우 최소 발송 희망 건수는 1000건입니다.');
                    return;
                }

                this.ajaxPostCreateCP();
            } else {
                alert('발송 타깃 선택 버튼을 눌러 모수조회를 먼저 진행하여야 합니다.');
            }
        } else if (targetType === "STADIUM" || targetType === "MAPTICS") {
            if (mapticsSendType === 'maptics_collect') {
                if (compareDateTimes(collStartDate, collEndDate) >= 0) {
                    alert("수집 기간의 종료 일정이 시작 일정보다 이전으로 설정되어 있습니다.\n올바른 발송 일정을 다시 설정해 주세요.");
                    return;
                }

                const collectionDeadline = getCollectionDeadline(collSndDate);
                if (compareDateTimes(collEndDate, collectionDeadline) > 0) {
                    alert("수집 종료는 발송 시각 10분 전까지 설정할 수 있습니다.");
                    return;
                }

                if (compareDateTimes(collEndDate, collStartDate) < 10 * 60 * 1000) {
                    alert("수집 기간은 최소 10분 이상 설정해 주세요.");
                    return;
                }
            } else if (mapticsSendType === 'maptics_realtime') {
                if (collStartDate >= collEndDate) {
                    alert("발송 기간의 종료 시각이 시작 시각보다 이전으로 설정되어 있습니다.\n올바른 발송 시각을 다시 설정해주세요.");
                    return;
                }
            }

            if(sndGoalCnt < 1000) {
                alert("최소 발송 건수는 1000건입니다.");
                return;
            }

            this.ajaxCreateMaptics(mapticsData)
        }
    }

    ajaxResetAtsMosu() {
        const { mosuJson, mosuCnt } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoadingMosu,
            loadingText: '발송 요청 수보다 추출된 모수가 너무 많아 40만 이하로 자동 조정됩니다.',
            url: "/api/category/ats/mosu/reset",
            method: apiUtil.requestMethod.POST,
            data: {
                mosuCnt: mosuCnt,
                mosuJson: mosuJson,
            },
            success: async (result) => {
                const { SelfAction } = this.props;

                await SelfAction.setMosuCnt(result.cnt);
                await SelfAction.setMosuQuery(result.query);
                await SelfAction.setMosuDesc(result.filterStr);
                await SelfAction.setMosuJson(result.mosuJson);

                await this.ajaxPostCreateCP();
            }
        });
    }

    setMosuData(data) {
        const { SelfAction } = this.props;

        SelfAction.setMosuCnt(data.cnt);
        SelfAction.setMosuQuery(data.query);
        SelfAction.setMosuDesc(data.filterStr);
        SelfAction.setMosuJson(data.mosuJson);
    }

    resetMosuData() {
        this.setMosuData({
            cnt: 0,
            query: '',
            filterStr: '',
            mosuJson: '',
        });
    }

    ajaxCreateMaptics(mapticsData) {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/maptics/create",
            method: apiUtil.requestMethod.POST,
            data: mapticsData,
            success: async (result) => {
                const { SelfAction } = this.props;
                await SelfAction.setMapticsTargetId(result);

                await this.ajaxPostCreateCP();
            }
        });
    }

    async ajaxPostCreateCP() {
        const { RCSFile, MMSFile } = this.props;

        const {
            name, RCSInfo, MmsInfo, howmany,
            rcsType, rcvType, billingType, callback, sndGoalCnt, atsSndStartDate,
            mosuCnt, mosuQuery, mosuDesc, mosuJson, sndNum,
            imgName, rewardUrl,
            targetType, mapticsSendType, collStartDate, collEndDate, collSndDate,
            rtEndHour, rtEndMinute, mapticsTargetId,
            aiCreated,
        } = this.props;

        const { selectedCoupon } = this.props;
        const { useReward, isRemind, usePackage, sendPeriod, isAIImage, selectedFormUid, isNaverLoginAdded, naverRedirectUrl, naverLoginText, tgtCompanyName } = this.state;

        if (!tgtCompanyName) {
            alert('고객사를 선택해주세요.');
            return;
        }

        let data = new FormData();
        // rcsType으로 이미지인지 텍스트인지 확인
        if (!isRcsText(rcsType)) {
            for (let i = 0; i < RCSFile.length; i++) {
                data.append("RCSFile", RCSFile[i]);
            }
            data.append("MMSFile", MMSFile);
        } else {
            data.append("RCSFile", null);
            data.append("MMSFile", null);
        }

        let rcvType1 = 0;
        let collEndDate1 = collEndDate;
        if (targetType === 'ATS') {
            rcvType1 = 0;
        } else if (targetType === 'STADIUM' || targetType === 'MAPTICS') {
            if (mapticsSendType === 'maptics_collect') {
                rcvType1 = 2;
            } else if (mapticsSendType === 'maptics_realtime') {
                rcvType1 = 1;
            }
        }

        let data2 = {
            name: name,
            sendDate: rcvType1 === 0 ? toApiDateTime(atsSndStartDate) : null,
            billingType: billingType,
            slidecount: howmany.length,
            rcsType: rcsType,
            rcs: RCSInfo,
            mms: MmsInfo,
            mosuCnt: rcvType1 === 0 ? mosuCnt : null,
            mosuQuery: rcvType1 === 0 ? mosuQuery : null,
            mosuDesc: rcvType1 === 0 ? mosuDesc : null,
            mosuJson: rcvType1 === 0 ? mosuJson : null,
            callback: callback,
            sendNumber: sndGoalCnt,
            couponId: selectedCoupon.uid,
            tgtCompanyName: tgtCompanyName,
            sndNum: sndNum,
            imgName: imgName,
            rewardUrl: useReward ? rewardUrl : null,

            rcvType: rcvType1,
            collStartDate: (rcvType1 === 1 || rcvType1 === 2) ? toApiDateTime(collStartDate) : null,
            collEndDate: (rcvType1 === 1 || rcvType1 === 2) ? toApiDateTime(collEndDate) : null,
            collSndDate: rcvType1 === 2 ? toApiDateTime(collSndDate) : null,
            rtStartHhmm: rcvType1 === 1 ? collStartDate.substr(11, 2) + collStartDate.substr(14, 2) : null,
            rtEndHhmm: rcvType1 === 1 ? rtEndHour + rtEndMinute : null,
            sndGeofenceId: (rcvType1 === 1 || rcvType1 === 2) ? mapticsTargetId : null,

            aiCreated: aiCreated,
            isRemind: isRemind,
            usePackage: usePackage,
            sendPeriod: sendPeriod,
            isAIImage: isAIImage,
            formUid: selectedFormUid,
            naverRedirectUrl: (isNaverLoginAdded === 'Y' || isRemind) ? naverRedirectUrl : null,
            naverLoginText: isNaverLoginAdded === 'Y' ? naverLoginText : null,
        }

        data.append('selfCreateRequest', JSON.stringify(data2));

        /*데이터 전송*/
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/create/self",
            method: apiUtil.requestMethod.POST,
            data: data,
            isFile: true,
            success: async (result) => {
                if (result.uid) {
                    const { SelfAction } = this.props;
                    SelfAction.setCreatedCampaignUid(result.uid);

                    this.openSuccessModal();
                }
            }
        })
    }// end ajaxPostCreate

    ajaxGetUserMessageInfo() {
        const { SelfAction } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/info/message",
            method: apiUtil.requestMethod.POST,
            success: (result) => {
                SelfAction.setCouponList(result.couponList);
                SelfAction.setPackage(result.userPackage);
                SelfAction.setCashAmount(result.amount);
                SelfAction.setFreeAmount(result.freeAmount);
                SelfAction.setTxtMessageUnit(result.txtMessageUnit);
                SelfAction.setImgMessageUnit(result.imgMessageUnit);
                if (result.userPackage !== null && result.userPackage !== undefined && result.userPackage?.type === 'I' && result.userPackage.canUsed === 'Y') {
                    SelfAction.setSndGoalCnt(result.userPackage.sendCnt);
                    this.setState({ usePackage: true });
                }
                this.setState({ userInfoData: result });
            }
        })
    }

    ajaxGetCompanyList() {
        apiUtil.asyncRequest({
            url: "/api/bizchat/user/companies",
            method: apiUtil.requestMethod.POST,
            data: {},
            success: (result) => {
                const companyList = result?.companies || [];
                this.setState((prevState) => {
                    const selectedCompanyExists = companyList.some(
                        (company) => company.companyName === prevState.tgtCompanyName
                    );
                    return {
                        companyList,
                        tgtCompanyName: selectedCompanyExists
                            ? prevState.tgtCompanyName
                            : companyList[0]?.companyName || ''
                    };
                });
            }
        });
    }

    handleCompanyChange(value) {
        const { SelfAction } = this.props;
        this.setState({ tgtCompanyName: value }, () => {
            SelfAction.setSelectedCoupon({});
        });
    }

    async handleCouponChange(e) {
        const { SelfAction } = this.props;
        const { sndGoalCnt } = this.props;

        const value = e.target.value;
        if (value === '') {
            await SelfAction.setSelectedCoupon({});
            return;
        }

        const parsedValue = JSON.parse(value);
        if (parsedValue.amount > sndGoalCnt) {
            alert('목표발송건수를 초과하는 쿠폰은 사용할 수 없습니다.');
            return;
        }

        await SelfAction.setSelectedCoupon(parsedValue);
    }

    handleRemindModal() {
        const { openRemindModal } = this.state;
        this.setState({ openRemindModal: !openRemindModal });
    }

    selectChargeType = (type) => {
        const { SelfAction, userPackage } = this.props;
        if (type === 'package') {
            this.setState({ usePackage: true });
            SelfAction.setSndGoalCnt(userPackage.sendCnt);
        } else {
            this.setState({ usePackage: false });
            SelfAction.setSndGoalCnt(1000);
        }
    }

    selectSendPeriod = (type) => {
        this.setState({ sendPeriod: type });
    }

    ajaxGetFileGuide() {
        apiUtil.fileDownloadRequest({
            url: "/api/bizchat/message/file/guide",
            method: apiUtil.requestMethod.GET,
            success: async (blob, filename) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename || '비즈팅_메시지_제작가이드.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        })
    }// end fileguid download

    ajaxGetFormList() {
        apiUtil.asyncRequest({
            url: "/api/user/forms/list",
            method: apiUtil.requestMethod.POST,
            data: {
                page: 1,
                size: 100, // 전체 리스트 조회 목적
                search: '',
            },
            success: (result) => {
                this.setState({ formList: result.content });
            }
        });
    }

    handleFormChange(name, value) {
        if (name === 'isFormAdded') {
            this.setState({
                isFormAdded: value,
                selectedFormUid: value === 'N' ? '' : this.state.selectedFormUid
            });
        } else if (name === 'selectedFormUid') {
            this.setState({ selectedFormUid: value });
        }
    }

    handleNaverLoginChange(name, value) {
        if (name === 'isNaverLoginAdded') {
            if (value === 'Y' && !this.state.hasNaverApp) {
                const confirmed = window.confirm('작성 중인 내용이 사라집니다.\n네이버 로그인 앱 생성 페이지로 이동하시겠습니까?');
                if (confirmed) {
                    window.location.href = '/attention';
                }
                return;
            }
            this.setState({
                isNaverLoginAdded: value,
                naverRedirectUrl: value === 'N' ? '' : this.state.naverRedirectUrl,
                naverLoginText: value === 'N' ? '' : this.state.naverLoginText,
            });
        } else if (name === 'naverRedirectUrl') {
            this.setState({ naverRedirectUrl: value });
        } else if (name === 'naverLoginText') {
            this.setState({ naverLoginText: value });
        }
    }

    render() {
        const { loading, loadingMosu, loadingText } = this.state;
        const { SelfAction } = this.props;

        const { couponList, selectedCoupon, cashAmount, freeAmount, txtMessageUnit, imgMessageUnit, userPackage } = this.props;
        const { handleCouponChange } = this;

        const { name, howmany, selectedSlide, atsSndStartDate, sndGoalCnt, mosuCnt } = this.props;
        const { handleCPInput, changePreview } = this;

        const { mapticsModal, mapticsSportsSelectModal } = this.state;

        const { targetType, mapticsSendType, collStartDate, collEndDate, collSndDate, rtEndHour, rtEndMinute, mapticsData } = this.props;
        const { handleTargetType, handleMapticsValue, handleMapticsSportsSelectModal, handleMapticsModal, setMapticsData } = this;

        const { RCSInfo, RCSType, urlCount, billingType, imgName } = this.props;
        const { handleRCSTypeChange, handleRCSInfoChange, setUrlValue, checkAtsMosuAndCreate, setMosuData, resetMosuData, setMessage, selectChargeType, selectSendPeriod } = this;

        const { chargeModal, chargeLackModal, successModal, mosuSelectModal, preview, isAIChecked, openRemindModal, handleRemindModal } = this.state;
        const { closeChargeModal, closeSuccessModal, closeChargeLackModal, handleMosuSelectModal } = this;

        const { createdCampaignUid, aiCreated, mosuJson } = this.props;
        const { resetMessage, setAiState, setIsAIImage } = this;
        const { isRemind, aiState, remindCmpnId, isRemindText, usePackage, isAIImage, formList, selectedFormUid, isFormAdded, isNaverLoginAdded, naverRedirectUrl, naverLoginText, companyList, tgtCompanyName } = this.state;
        const scheduleLimits = getSelfScheduleLimits({
            targetType,
            mapticsSendType,
            atsSndStartDate,
            collStartDate,
            collEndDate,
            collSndDate,
            rtEndHour,
            rtEndMinute,
        }, { isRemind });

        return (
            <div className='container-xxl self-message pb-4'>
                <Loading loading={loading || loadingMosu} text={loadingText} />
                <h2 className="fs-4">메시지 등록</h2>

                {/*화면설계도 상 추가된 내용 P.31*/}
                <div className={"info-content-item shadow"}>
                    <h5 className=' d-flex align-items-center'>
                        <span className="material-symbols-outlined text-primary fs-4 pe-2 fw-bold">report</span>
                        <span>셀프 메시지 등록</span>
                    </h5>
                    <ol className='fs-6 mb-2 fw-normal fs-4 ps-4 ps-sm-5'>
                        <li>원하시는 메시지 문구 및 이미지를 제작하여 메시지를 발송할 수 있습니다.</li>
                        <li>메시지 검수 과정에서 문구 밎 이미지 수정이 있을 수 있습니다.</li>
                        <li>메시지 발송 시 희망하는 타겟 연령을 설정하여 발송이 가능합니다.</li>
                        <li>메시지 검수는 대략 3~5 영업일 소요됩니다.</li>
                        <li style={{color:'red'}}>분양 광고는 반드시 <strong>1:1 문의</strong> 부탁드립니다. 비즈팅 사이트 내에서는 분양광고 진행이 어려우며, <strong>대행발송으로 진행</strong>되는 점 참고 부탁드립니다. <strong>포인트 충전 전 반드시 확인 부탁드립니다.</strong></li>
                    </ol>
                    <span>
                        <button
                            onClick={() => window.open(
                                "https://biztalk-tf.notion.site/2df27bc799fa80c48401eb2cfbba6563",
                                "_blank",
                                "noopener,noreferrer"
                            )}
                            className={"ms-4 btn btn-primary btn-sm d-flex align-items-center"}>
                            <span>제작가이드 </span>
                            <span className="material-symbols-rounded fs-5">download</span>
                        </button>
                    </span>
                </div>

                <div className='card'>
                    <div className='card-body'>
                        {/*미리보기 + 메시지 등록 영역*/}
                        <div className='row position-relative'>
                            <div className='col-lg-4 message-area'>
                                {/*미리보기 들어갈 곳*/}
                                <div>
                                    <div className='phone-box'>
                                        <div className='title'>
                                            {/*1a에 해당하는 유형*/}
                                            <h5>{RCSType}</h5>
                                            <small className='small'>미리보기</small>
                                        </div>
                                        <div className='phone-body p-2'>
                                            {/*1b에 해당하는 미리보기 영역*/}
                                            {/* 기본 화면 */}
                                            {
                                                RCSType !== "텍스트" &&
                                                <div>
                                                    <h6 className={'text-center mt-5' + (preview !== null ? ' visually-hidden' : '')}>화면을 클릭해 <br /> 이미지를 선택하세요.</h6>
                                                    <img
                                                        className={preview !== null ? '' : 'icon_plus'}
                                                        src={preview !== null ? preview : "../../assets/img/img_plus.png"}
                                                        alt={"이미지"}
                                                        onClick={!isRemind ? () => this.imageButtonRef.current.openImageListModal() : undefined}
                                                    />
                                                </div>
                                            }
                                            <>
                                                <h6>{RCSInfo[selectedSlide - 1].title}</h6>
                                                <br />
                                                <small dangerouslySetInnerHTML={{ __html: (() => {
                                                    const originalMsg = RCSInfo[selectedSlide - 1].msg;
                                                    if (!originalMsg) return '';

                                                    // 설문이 선택된 경우 미리보기에 설문 링크 표시 (RCSInfo 원본은 변경하지 않음)
                                                    const selectedForm = isFormAdded === 'Y' && selectedFormUid
                                                        ? formList.find(f => String(f.uid) === String(selectedFormUid))
                                                        : null;

                                                    let displayMsg = originalMsg;
                                                    const DISCLAIMER = '※ 이 메시지는 SK텔레콤에서 혜택/광고 수신에 동의하신 고객님께 보내 드렸습니다.';

                                                    if (selectedForm) {
                                                        const surveyText = `▶ 설문참여하기: ${selectedForm.formUrl}`;
                                                        if (displayMsg.includes(DISCLAIMER)) {
                                                            displayMsg = displayMsg.replace(DISCLAIMER, surveyText + '\n\n' + DISCLAIMER);
                                                        } else {
                                                            displayMsg = displayMsg + surveyText;
                                                        }
                                                    }

                                                    if (isNaverLoginAdded === 'Y' && naverLoginText && naverLoginText.trim()) {
                                                        const naverPreviewText = `${naverLoginText.trim()}: https://www.bizting.co.kr/naver/(생성예정)`;
                                                        const surveyText = selectedForm ? `▶ 보러가기: ${selectedForm.formUrl}` : null;
                                                        if (surveyText && displayMsg.includes(surveyText)) {
                                                            displayMsg = displayMsg.replace(surveyText, naverPreviewText + '\n\n' + surveyText);
                                                        } else if (displayMsg.includes(DISCLAIMER)) {
                                                            displayMsg = displayMsg.replace(DISCLAIMER, naverPreviewText + '\n\n' + DISCLAIMER);
                                                        }
                                                    }

                                                    return stringUtil.convertNewlineToBr(displayMsg);
                                                })() }}></small>
                                            </>
                                            <div className={"btn-area"}>
                                                {
                                                    RCSInfo[selectedSlide - 1]?.buttons?.list?.map((button, index) => (
                                                        <SingleButton
                                                            key={index}
                                                            className={index === 0 ? "btn btn-light btn-sm w-100 my-2" : "btn btn-light btn-sm w-100 mb-2"}
                                                            label={button.name}
                                                        />
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*29페이지 2번, 3번에 해당하는 메시지 입력 부분*/}
                            <div className='col-lg-8 message-form pe-lg-5 pt-3 pt-lg-0'>
                                <div className='container'>
                                    <div className="row">
                                        <div className='row pe-0'>
                                            <div className='pb-3 pt-2'>
                                                <h5>타겟팅 유형</h5>
                                                <RadioBtnList
                                                    id="targetType"
                                                    list={
                                                        isRemind
                                                            ? (targetType === "ATS"
                                                                ? [{ label: '일반 타겟팅', value: 'ATS' }]
                                                                :
                                                                targetType === "MAPTICS" ?
                                                                    [{ label: '체류 위치 타겟팅', value: 'MAPTICS' }]
                                                                    :
                                                                    [{ label: '스포츠 경기장 타겟팅', value: 'STADIUM' }])
                                                            : [
                                                                { label: '일반 타겟팅', value: 'ATS' },
                                                                { label: '체류 위치 타겟팅', value: 'MAPTICS' },
                                                                { label: '스포츠 경기장 타겟팅', value: 'STADIUM' },
                                                            ]
                                                    }
                                                    value={targetType}
                                                    onChange={handleTargetType}
                                                />
                                            </div>
                                            {
                                                userPackage !== null && userPackage !== undefined && userPackage.canUsed === 'Y' && ((userPackage.type === 'T' && billingType === 3)
                                                    || (userPackage.type === 'I' && billingType === 1)) &&
                                                <>
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                            <h5 className='d-inline-block mb-0 h-fix'>플랜 구분</h5>
                                                        </div>
                                                        <div className="d-flex">
                                                            <select
                                                                className="form-select w-auto"
                                                                defaultValue="package"
                                                                onChange={(e) => selectChargeType(e.target.value)}
                                                            >
                                                                <option value="package">패키지</option>
                                                                <option value="point">포인트</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    { usePackage &&
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <Tooltip title={
                                                            <div>
                                                                <p className={"mb-0"}>첫 캠페인의 목표 발송일을 기준일로 하여,</p>
                                                                <p className={"mb-0"}>선택한 자동 발송 간격(일)에 따라</p>
                                                                <p className={"mb-0"}>각 회차 메시지가 순차적으로 발송될 예정입니다.</p>
                                                            </div>
                                                        }>
                                                            <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                                <h5 className='d-inline-block mb-0 h-fix'>발송 주기</h5>
                                                                <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                                            </div>
                                                        </Tooltip>
                                                        <div className="d-flex">
                                                            <select
                                                                className="form-select w-auto"
                                                                defaultValue="7"
                                                                onChange={(e) => selectSendPeriod(e.target.value)}
                                                            >
                                                                <option value="5">5일</option>
                                                                <option value="7">7일</option>
                                                                <option value="10">10일</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    }
                                                </>

                                            }
                                        </div>
                                        {
                                            targetType === "ATS" &&
                                            <>
                                                <div className='row pe-0'>
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <Tooltip title= { targetType === "ATS" ? (
                                                            <div>
                                                                <p className={"mb-0"}>목표 발송 건수는</p>
                                                                <p className={"mb-0"}>최대 100000 (10만) 건 까지</p>
                                                                <p className={"mb-0"}>입력 가능합니다.</p>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <p className={"mb-0"}>목표 발송 건수는</p>
                                                                <p className={"mb-0"}>최소 1000 (천) 건</p>
                                                                <p className={"mb-0"}>최대 100000 (10만) 건 까지</p>
                                                                <p className={"mb-0"}>입력 가능합니다.</p>
                                                            </div>
                                                            )
                                                        }>
                                                            <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                                <h5 className='d-inline-block mb-0 h-fix'>목표 발송 건수</h5>
                                                                <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                                            </div>
                                                        </Tooltip>
                                                        <TextInput
                                                            className='form-control'
                                                            id="sndGoalCnt"
                                                            name="sndGoalCnt"
                                                            value={sndGoalCnt}
                                                            onChange={handleCPInput}
                                                            readOnly={usePackage}
                                                        />
                                                    </div>
                                                    <div className='col-lg-6 pe-0 pt-2 pb-3'>
                                                        <Tooltip title={`등록 메시지는 검수가 필요하기에 영업일 기준 ${isRemind ? 3 : 5}일 이후부터 발송이 가능합니다.`}>
                                                            <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                                <h5 className='d-inline-block mb-0 h-fix'>목표 발송 일자</h5>
                                                                <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                                            </div>
                                                        </Tooltip>
                                                        <CampaignDateTimeInput
                                                            className={'form-control'}
                                                            inputName="sendDate"
                                                            value={atsSndStartDate}
                                                            minDate={scheduleLimits.atsSndStartDate.minDate}
                                                            maxTime="20:00"
                                                            onChange={handleCPInput}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row pe-0">
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <h5 className='d-flex align-items-center'>발송 유형
                                                            {!isRemind &&
                                                                <Tooltip title={
                                                                    <div>
                                                                        <p className='fw-bold mb-1'>통합유형이란?</p>
                                                                        <p className='mb-0'>아이폰과 안드로이드 모두 RCS 타입으로 발송할 수 있는 유형입니다. 통합유형이 아닌 경우에는 안드로이드에서만 RCS 발송이 가능합니다</p>
                                                                    </div>
                                                                }>
                                                                    <button type='button' className='btn btn-link p-0 border-0 d-inline-flex align-items-center' aria-label='통합유형 안내'>
                                                                        <span className='material-symbols-rounded fs-5 ps-2 text-primary' aria-hidden='true'>info</span>
                                                                    </button>
                                                                </Tooltip>
                                                            }
                                                        </h5>
                                                        {!isRemind && <select className="form-select mb-2" value={this.props.rcsType} onChange={e => handleRCSTypeChange('RCSType', e.target.value)}>
                                                            {RCS_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
                                                        </select>}
                                                        {isRemind === false ?
                                                            (null)
                                                            :
                                                            (
                                                                <RadioBtnList
                                                                    id="RCSType"
                                                                    list={
                                                                        RCSType !== "텍스트"
                                                                            ? [{ label: '이미지', value: '이미지' }]
                                                                            : [{ label: '텍스트', value: '텍스트' }]
                                                                    }
                                                                    value={RCSType}
                                                                    onChange={handleRCSTypeChange}
                                                                />)
                                                        }
                                                    </div>
                                                    <div className='col-lg-6 pe-0 pt-2 pb-3'>
                                                        <h5>발송 타깃</h5>
                                                        <div className='d-flex align-items-center v-align-custom'>
                                                            {/*{mosuJson}*/}
                                                            <button className='btn btn-primary btn-sm' onClick={handleMosuSelectModal}>{isRemind ? '모수확인' : '모수선택'}</button>
                                                            {/* 07-31 input -> span으로 변경 - 승범 */}
                                                            <input
                                                                className='form-control ms-1 me-0'
                                                                value={mosuCnt.toLocaleString() + " 명"}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {
                                            (targetType === "STADIUM" || targetType === "MAPTICS") &&
                                            <>
                                                <div className='row pe-0'>
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <h5 className="d-flex align-items-center">목표 발송 건수
                                                            {
                                                                (!usePackage && sndGoalCnt < 1000 || sndGoalCnt > 100000) &&
                                                                <Tooltip title={
                                                                    <div>
                                                                        <p className={"mb-0"}>최소 1000 (천) 건</p>
                                                                        <p className={"mb-0"}>최대 100000 (10만) 건</p>
                                                                        <p>으로 등록 하셔야합니다.</p>
                                                                    </div>
                                                                }>
                                                                    <span className="material-symbols-rounded fs-5 ps-1" style={{ color: 'red' }}>info</span>
                                                                </Tooltip>
                                                            }
                                                        </h5>
                                                        <TextInput
                                                            className='form-control'
                                                            id="sndGoalCnt"
                                                            name="sndGoalCnt"
                                                            value={sndGoalCnt}
                                                            onChange={handleCPInput}
                                                        />
                                                    </div>
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <h5 className='d-flex align-items-center'>발송 유형
                                                            {isRemind === false &&
                                                                <Tooltip title={
                                                                    <div>
                                                                        <p className='fw-bold mb-1'>통합유형이란?</p>
                                                                        <p className='mb-0'>아이폰과 안드로이드 모두 RCS 타입으로 발송할 수 있는 유형입니다. 통합유형이 아닌 경우에는 안드로이드에서만 RCS 발송이 가능합니다</p>
                                                                    </div>
                                                                }>
                                                                    <button type='button' className='btn btn-link p-0 border-0 d-inline-flex align-items-center' aria-label='통합유형 안내'>
                                                                        <span className='material-symbols-rounded fs-5 ps-2 text-primary' aria-hidden='true'>info</span>
                                                                    </button>
                                                                </Tooltip>
                                                            }
                                                        </h5>
                                                        {isRemind === false ?
                                                            (<React.Fragment><select className="form-select mb-2" value={this.props.rcsType} onChange={e => handleRCSTypeChange('RCSType', e.target.value)}>
                                                                {RCS_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
                                                            </select></React.Fragment>)
                                                            :
                                                            (<RadioBtnList
                                                                id="RCSType"
                                                                list={
                                                                    RCSType !== "텍스트"
                                                                        ? [{ label: '이미지', value: '이미지' }]
                                                                        : [{ label: '텍스트', value: '텍스트' }]
                                                                }
                                                                value={RCSType}
                                                                onChange={handleRCSTypeChange}
                                                            />)
                                                        }
                                                    </div>
                                                </div>
                                                <div className="row pe-0">
                                                    <div className='col-lg-6 pe-0 pt-2 pb-3'>
                                                        <h5>{isRemind ? '타겟 확인하기' : '타겟 설정하기'}</h5>
                                                        <div className='d-flex align-items-center v-align-custom'>
                                                            {
                                                                targetType === "STADIUM" &&
                                                                <SingleButton
                                                                    className='btn btn-primary btn-sm'
                                                                    label={!isRemind ? "선택" : "확인"}
                                                                    handleClick={handleMapticsSportsSelectModal}
                                                                />
                                                            }
                                                            {
                                                                targetType === "MAPTICS" &&
                                                                <SingleButton
                                                                    className='btn btn-primary btn-sm'
                                                                    label={!isRemind ? "선택" : "확인"}
                                                                    handleClick={handleMapticsModal}
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                        <h5>보내기 유형</h5>
                                                        <SelectList
                                                            id="mapticsSendType"
                                                            className='form-select'
                                                            list={[
                                                                { label: '모아서 보내기', value: 'maptics_collect' },
                                                                { label: '실시간 보내기', value: 'maptics_realtime' },
                                                            ]}
                                                            value={mapticsSendType}
                                                            onChange={handleMapticsValue}
                                                            disableDefault
                                                            disabled={isRemind}
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                    mapticsSendType === 'maptics_collect' &&
                                                    <>
                                                        <div className="row pe-0">
                                                            <div className='col-lg-6 pe-0 pb-3 pt-2'>
                                                                <h5>발송 날짜</h5>
                                                                <CampaignDateTimeInput
                                                                    className={'form-control'}
                                                                    inputName="collSndDate"
                                                                    value={collSndDate}
                                                                    minDate={scheduleLimits.collSndDate.minDate}
                                                                    hourList={dateUtil.hourListForMapticsSchedule}
                                                                    maxTime="20:00"
                                                                    onChange={handleMapticsValue}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row pe-0">
                                                            <div className='col-lg-6 pe-0 pt-2 pb-3'>
                                                                {
                                                                    targetType === "STADIUM" ?
                                                                    <Tooltip title={"평일 프로야구의 경기 개시 시간은 18시 30분입니다. 발송 시간 선택에 참고하시기 바랍니다."}>
                                                                        <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                                            <h5 className='d-inline-block mb-0 h-fix'>수집 기간</h5>
                                                                            <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                                                        </div>
                                                                    </Tooltip>
                                                                    :
                                                                    <h5>수집 기간</h5>
                                                                }
                                                                <div className='d-flex align-items-center v-align-custom'>
                                                                    <CampaignDateTimeInput
                                                                        className={'form-control'}
                                                                        inputName="collStartDate"
                                                                        value={collStartDate}
                                                                        minDate={scheduleLimits.collStartDate.minDate}
                                                                        hourList={dateUtil.hourListForMapticsCollect}
                                                                        maxDate={scheduleLimits.collStartDate.maxDate}
                                                                        maxDateTime={scheduleLimits.collStartDate.maxDateTime}
                                                                        onChange={handleMapticsValue}
                                                                    />
                                                                    &nbsp;&nbsp;~&nbsp;&nbsp;
                                                                    <CampaignDateTimeInput
                                                                        className={'form-control'}
                                                                        inputName="collEndDate"
                                                                        value={collEndDate}
                                                                        minDate={scheduleLimits.collEndDate.minDate}
                                                                        hourList={dateUtil.hourListForMapticsCollect}
                                                                        maxDate={scheduleLimits.collEndDate.maxDate}
                                                                        maxDateTime={scheduleLimits.collEndDate.maxDateTime}
                                                                        onChange={handleMapticsValue}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </>
                                                }
                                                {
                                                    mapticsSendType === 'maptics_realtime' &&
                                                    <>
                                                        <div className="row pe-0">
                                                            <div className='col-lg-6 pe-0 pt-2 pb-3'>
                                                                {
                                                                    targetType === "STADIUM" ?
                                                                        <Tooltip title={"평일 프로야구의 경기 개시 시간은 18시 30분입니다. 발송 시간 선택에 참고하시기 바랍니다."}>
                                                                            <div className='d-inline-flex align-items-center mb-2 pointer'>
                                                                                <h5 className='d-inline-block mb-0 h-fix'>발송 기간</h5>
                                                                                <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                                                            </div>
                                                                        </Tooltip>
                                                                        :
                                                                        <h5>발송 기간</h5>
                                                                }
                                                                <div className='d-flex align-items-center v-align-custom'>
                                                                    <CampaignDateTimeInput
                                                                        className={'form-control'}
                                                                        inputName="collStartDate"
                                                                        value={collStartDate}
                                                                        minDate={scheduleLimits.collStartDate.minDate}
                                                                        hourList={dateUtil.hourListForMapticsSend}
                                                                        onChange={handleMapticsValue}
                                                                    />
                                                                    &nbsp;&nbsp;~&nbsp;&nbsp;
                                                                    <div className={'d-flex'}>
                                                                        <SelectList
                                                                            className="form-select d-inline w-auto"
                                                                            id="rtEndHour"
                                                                            value={rtEndHour}
                                                                            list={dateUtil.hourListForMapticsSend}
                                                                            onChange={handleMapticsValue}
                                                                            disableDefault={true}
                                                                        />
                                                                        <span className='mt-1 mx-1'>시</span>
                                                                        <SelectList
                                                                            className="form-select d-inline w-auto"
                                                                            id="rtEndMinute"
                                                                            value={rtEndMinute}
                                                                            list={dateUtil.minuteList}
                                                                            onChange={handleMapticsValue}
                                                                            disableDefault={true}
                                                                        />
                                                                        <span className='mt-1 mx-1'>분</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        }
                                        {
                                            isRemind === false && RCSType === '이미지' &&
                                            <div className='row pe-0'>
                                                <div className='pe-0 pb-3 pt-2'>
                                                    <span className="fs-7 text-muted d-block">
                                                        * 등록 가능한 이미지 파일 형식은 <strong>jpg, jpeg</strong>뿐입니다. 다른 형식의 파일은 등록할 수 없습니다.
                                                    </span>
                                                    <span className="fs-7 text-muted">
                                                        * AI 기본법에 따라 AI로 생성한 이미지는 반드시 체크해 주세요. 체크 시 메시지에 AI 생성 이미지 안내 문구가 자동으로 포함됩니다.
                                                    </span>
                                                    <div className="form-check mt-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="isAIImage"
                                                            checked={isAIImage}
                                                            onChange={(e) => setIsAIImage(e.target.checked)}
                                                        />
                                                        <label className="form-check-label" htmlFor="isAIImage">
                                                            AI 생성 이미지 여부
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {/*29페이지 3번 설명은 30페이지 RCSFundamen 이라는 COMP로 RCS제목, 내용 입력 받음*/}
                                        {/* 초기에 RCS-슬라이드 등의 선택지 있었고 추가될 예정이라고 전달 받음 */}
                                        {/* RCS발송에 필요한 사항만 해당 COMP에 있음 */}
                                        {
                                            RCSType !== "슬라이드" &&
                                            /* RCSFundamenFormClass 는 단일 형 (텍스트, 이미지) */
                                            <RCSFundamenFormClass
                                                SelfAction={SelfAction}
                                                RCSInfo={RCSInfo}   // RCS정보 (type : [])
                                                RCSType={RCSType} // 텍스트 or 이미지
                                                rcsType={this.props.rcsType}
                                                urlCount={urlCount}
                                                index={selectedSlide - 1}   // RCSInfo의 index props로 넘겨 미리보기 및 reducer를 통한 정보 기억을 위함
                                                imgName={imgName}
                                                handleRCSInfoChange={handleRCSInfoChange}
                                                setCPValue={handleCPInput}
                                                setUrlValue={setUrlValue}
                                                changePreview={changePreview}
                                                aiCreated={aiCreated}
                                                setMessage={setMessage}
                                                resetMessage={resetMessage}
                                                onAICheckChange={this.handleAICheckChange}
                                                ref={this.imageButtonRef}
                                                onAIStateChange={(aiState) => this.setState({ aiState })}
                                                isRemind={isRemind}
                                                aiState={aiState}
                                                isRemindText={isRemindText}
                                                setAiState={setAiState}
                                                handleRemindModal={this.handleRemindModal}
                                                resetRemindMessage={this.resetRemindMessage}
                                                formList={formList}
                                                selectedFormUid={selectedFormUid}
                                                isFormAdded={isFormAdded}
                                                handleFormChange={this.handleFormChange}
                                                hasNaverApp={this.state.hasNaverApp}
                                                isNaverLoginAdded={isNaverLoginAdded}
                                                naverRedirectUrl={naverRedirectUrl}
                                                naverLoginText={naverLoginText}
                                                handleNaverLoginChange={this.handleNaverLoginChange}
                                                companyList={companyList}
                                                selectedTgtCompanyName={tgtCompanyName}
                                                onTgtCompanyNameChange={this.handleCompanyChange}
                                            />
                                        }

                                        {/*이 밑에부터 초기 모델에서 사용 안될 예정입니다!*/}
                                        {RCSType === "슬라이드" && <></>
                                            // <RCSSlideCountComp
                                            //     SelfAction={SelfAction}
                                            // />
                                        }
                                        {RCSType === "슬라이드" && howmany.map((item, idx) => (
                                            <div key={idx} className={selectedSlide !== item ? "visually-hidden" : ""}>
                                                {item} 번째 슬라이드 확인중
                                                {/*<RCSFundamenForm key={item} index={item} messageType={RCSType}/>*/}
                                            </div>
                                        ))}
                                        {/*{RCSType === "RCS-상품 소개 세로" && <RCSAdditionalIMGComp/>}*/}
                                        {/*이 위에까지!! */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* MMS 발송에 필요한 정보만 해당 COMP에 있음 */}
                        {/* MMS 입력 포맷 삭제 2025-03-26 midas */}

                        <CouponChargeComp
                            couponList={couponList}
                            selectedCoupon={selectedCoupon}
                            cashAmount={cashAmount}
                            freeAmount={freeAmount}
                            sndGoalCnt={sndGoalCnt}
                            billingType={billingType}
                            txtMessageUnit={txtMessageUnit}
                            imgMessageUnit={imgMessageUnit}
                            handleCouponChange={handleCouponChange}
                            userPackage={userPackage}
                            usePackage={usePackage}
                            selectedTgtCompanyName={tgtCompanyName}
                        />

                        <div className={"d-flex py-3 justify-content-center"}>
                            <button onClick={() => {
                                if (window.confirm('메시지 등록을 취소하시겠습니까? 입력한 모든 내용이 삭제됩니다.')) {
                                    window.location.reload();
                                }
                            }} className={"mx-3 btn btn-md btn-secondary"}>취소
                            </button>
                            <button className='btn btn-md btn-primary' onClick={checkAtsMosuAndCreate}>확인</button>
                        </div>

                        {/*28페이지 맨 처음 결제를 유도하는 모달*/}
                        <ChargeModalBeforeCreate isOpen={chargeModal} isClose={closeChargeModal} />
                        {/*메시지가 저장되면 보여질 모달*/}
                        <MessageSavedModal
                            open={successModal}
                            isClose={closeSuccessModal}
                            type="self"
                            campaignUid={createdCampaignUid}
                            isRemind={isRemind}
                        />
                        {/*금액이 부족하면 열리는 모달*/}
                        <ChargePressModal isOpen={chargeLackModal} isClose={closeChargeLackModal} />

                        <MessageMosuSelectModal
                            isOpen={mosuSelectModal}
                            handleClose={handleMosuSelectModal}
                            setMosuData={setMosuData}
                            resetMosuData={resetMosuData}
                            sndMosuJson={mosuJson}
                            isRemind={isRemind}
                            remindCmpnId={remindCmpnId}
                        />
                        <MessageMapticsSportsSelectModal
                            isOpen={mapticsSportsSelectModal}
                            handleClose={handleMapticsSportsSelectModal}
                            setMapticsData={setMapticsData}
                            mapticsData={mapticsData}
                            isRemind={isRemind}
                        />
                        <MessageMapticsModal
                            isOpen={mapticsModal}
                            handleClose={handleMapticsModal}
                            setMapticsData={setMapticsData}
                            mapticsData={mapticsData}
                            isRemind={isRemind}
                        />
                        <GetMessageForRemindModal
                            isOpen={openRemindModal}
                            handleClose={() => this.handleRemindModal(false)}
                            setValue={handleCPInput}
                        />
                    </div>
                </div>
            </div>
        )
    }// end render
}// end class


export default connect(
    (state) => ({
        RCSInfo: state.selfmessage.RCSInfo,
        MmsInfo: state.selfmessage.MmsInfo,

        name: state.selfmessage.name,

        targetType: state.selfmessage.targetType,
        mapticsSendType: state.selfmessage.mapticsSendType,
        collStartDate: state.selfmessage.collStartDate,
        collEndDate: state.selfmessage.collEndDate,
        collSndDate: state.selfmessage.collSndDate,
        rtEndHour: state.selfmessage.rtEndHour,
        rtEndMinute: state.selfmessage.rtEndMinute,
        mapticsData: state.selfmessage.mapticsData,
        mapticsTargetId: state.selfmessage.mapticsTargetId,

        rcvType: state.selfmessage.rcvType,
        billingType: state.selfmessage.billingType,
        rcsType: state.selfmessage.rcsType,

        couponList: state.selfmessage.couponList,
        selectedCoupon: state.selfmessage.selectedCoupon,
        cashAmount: state.selfmessage.cashAmount,
        freeAmount: state.selfmessage.freeAmount,
        txtMessageUnit: state.selfmessage.txtMessageUnit,
        imgMessageUnit: state.selfmessage.imgMessageUnit,

        callback: state.selfmessage.callback,
        sndNum: state.selfmessage.sndNum,
        sndGoalCnt: state.selfmessage.sndGoalCnt,
        atsSndStartDate: state.selfmessage.atsSndStartDate,

        ageTo: state.selfmessage.ageTo,
        ageFrom: state.selfmessage.ageFrom,
        mosuCnt: state.selfmessage.mosuCnt,
        mosuQuery: state.selfmessage.mosuQuery,
        mosuDesc: state.selfmessage.mosuDesc,
        mosuJson: state.selfmessage.mosuJson,

        RCSType: state.selfmessage.RCSType,
        messageType: state.selfmessage.messageType,

        urlCount: state.selfmessage.urlCount,
        mmsUrlCount: state.selfmessage.mmsUrlCount,
        buttonCount: state.selfmessage.buttonCount,

        RCSFile: state.selfmessage.RCSFile,
        MMSFile: state.selfmessage.MMSFile,
        imgName: state.selfmessage.imgName,

        rewardUrl: state.selfmessage.rewardUrl,

        howmany: state.selfmessage.howmany,
        selectedSlide: state.selfmessage.selectedSlide,

        files: state.selfmessage.files,

        createdCampaignUid: state.selfmessage.createdCampaignUid,

        aiCreated: state.selfmessage.aiCreated,
        userPackage: state.selfmessage.userPackage,
    }),
    (dispatch) => ({
        SelfAction: bindActionCreators(selfAction, dispatch)
    })
)(SelfMessageCreateContainer);
